module.exports = __webpack_public_path__ + "static/media/photo3.ca63459d.jpg";